import * as React from "react";
import {
    makeStyles,
    tokens
} from "@fluentui/react-components";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { shorthands } from "@fluentui/react-components";
import { flexColumn } from "../styles/GlobalStyles";
import { CookieBanner } from "./CookieBanner";

const useStyles = makeStyles({
    body: {
        overflowY: "auto",
        display: "flex",
        height: "100%",
        boxSizing: "border-box"
    },
    root: {
        ...flexColumn,
        ...shorthands.margin("0px"),
        backgroundColor: tokens.colorNeutralBackground1,
        gap: "0px",
        height: "100%"
    }
});

export const NavbarWrapper: React.FC<any> = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Navbar />

            <div id="body" className={classes.body}>
                <Outlet />
            </div>

            <CookieBanner />
        </div>
    );
};